module.exports = __webpack_public_path__ + "img/tombelaine_integrale_cover.e2203860.jpg";